import { createContext } from 'react';

const UserContext = createContext({
  isAuthenticated: false,
  username: '',
});

export default UserContext;
